// extracted by mini-css-extract-plugin
module.exports = {"image":"d7xFyJ"};